export default {
    mapIconPicker_error: "Error while getting maps icons",
    mapIconPicker_places: "Places",
    mapIconPicker_maps: "Maps",
    mapIconPicker_chooseIcon: "choose icon",
    mapIconPicker_defaultIcon: "default icon",
    mapIconPicker_chooseColor: "choose color",
};